function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st3{fill:#878787;}\n\t.st4{fill:#E30613;}\n\t.st5{fill:#009FE3;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M400,0v81.57c-17.19-2.34-42.54-6.98-69.54-17.11c-40.37-15.14-40.92-26.22-73.12-33.19 c-37.6-8.14-64.85,0.92-78.74-10.72c-7.53-6.31-6.51-14.84-4.82-20.55C249.19,0,324.59,0,400,0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M400,153.57c0,94.62,0,189.23,0,283.85c-19.21-11-73.92-44.86-90.49-95.42c-7.53-22.98-5.42-44.03-5.07-47.23 c2.59-23.55,12.22-41.03,17.16-49.79c4.62-8.19,3.2-3.97,21.05-30.38c15.24-22.54,18.54-28.98,28.46-38.81 C381.69,165.31,392.75,157.95,400,153.57z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M400,459.96V650H231.1C188.12,528.97,250.27,469.02,400,459.96z"
});

function SvgRightShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 650",
    style: {
      enableBackground: "new 0 0 400 650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightShape);
export default __webpack_public_path__ + "static/media/RightShape.aa3ee42a.svg";
export { ForwardRef as ReactComponent };